// Recipient derivation for the portal email sender (E4 Layer 1).
//
// Mirrors the Email Announcements surface: guardian/parent emails come from the
// SAME student fields the announcement blast uses (parent1 / parent2). We do NOT
// invent a new email field. When a student has no guardian email on file, fall
// back to the student's own email so the family is still reachable.

const fullName = (person) =>
	[person?.firstName, person?.lastName].filter(Boolean).join(' ').trim();

export const studentDisplayName = (student) =>
	student?.fullName || fullName(student) || 'Student';

// → [{ name, email }] for one student's family (deduped, valid-shaped).
export function guardiansForStudent(student) {
	if (!student) return [];
	const name = studentDisplayName(student);
	const out = [];
	const seen = new Set();
	const push = (label, email) => {
		const e = String(email || '').trim().toLowerCase();
		if (!e || seen.has(e)) return;
		seen.add(e);
		out.push({ name: label, email: e });
	};

	if (student.parent1?.email) {
		const pName = fullName(student.parent1);
		push(pName ? `${pName} (${name}'s parent)` : `${name}'s parent`, student.parent1.email);
	}
	if (student.parent2?.email) {
		const pName = fullName(student.parent2);
		push(pName ? `${pName} (${name}'s parent)` : `${name}'s parent`, student.parent2.email);
	}
	// Fallback: no guardian email → the student's own address, if present.
	if (out.length === 0 && student.email) {
		push(name, student.email);
	}
	return out;
}

// Build typeahead suggestions from the roster. Each suggestion matches on the
// student name AND the family (last) name; both resolve to the family's
// guardian emails.
export function buildSuggestions(students = []) {
	return students
		.map((student) => {
			const guardians = guardiansForStudent(student);
			return {
				id: student.id,
				studentName: studentDisplayName(student),
				familyName: student.lastName || '',
				guardians,
			};
		})
		.sort((a, b) => a.studentName.localeCompare(b.studentName));
}
